import NoFoundComponent from "../components/NoFoundComponent";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "../pages/HomePage";
import LayoutComponent from "../components/layout/LayoutComponent";
import ProductPage from "../pages/ProductPage";
import { createBrowserHistory } from "history";
import ProjectPage from "../pages/ProjectPage";
const history = createBrowserHistory();

export default function LandingRoutes() {
  return (
    <BrowserRouter history={history}>
      <Routes history={history}>
        <Route path="/">
          <Route
            index
            element={
              <LayoutComponent>
                <HomePage />
              </LayoutComponent>
            }
          />
          <Route
            path="/products"
            element={
              <LayoutComponent>
                <ProductPage />
              </LayoutComponent>
            }
          />
          <Route
            path="/projects"
            element={
              <LayoutComponent>
                <ProjectPage />
              </LayoutComponent>
            }
          />
          <Route path="*" element={<NoFoundComponent />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
